<template>
  <div class="invoice-list">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="发票管理"
      left-arrow
      @click-left="back"
      style="font-size: 12px; color: #333333;"
    />

    <!-- 选项卡：待开票 / 已开票 -->
    <van-tabs v-model="activeTab" @change="handleTabChange">
      <van-tab title="待开票" />
      <van-tab title="已开票" />
    </van-tabs>

    <!-- 月份选择器 -->
    <div class="month-picker" @click="showMonthPicker = true">
      <van-icon name="calendar" />
      <span>{{ selectedMonth }}</span>
    </div>

    <!-- 上下拉刷新组件 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- 发票列表 -->
      <div class="invoice-container">
        <van-list>
          <van-cell
            v-for="(item, index) in filteredInvoiceList"
            :key="index"
          >
            <!-- 乘车日期 -->
            <div class="travel-date">
              乘车日期：{{ formatDate(item.travelDate) }}
            </div>

            <!-- 订单号单独一行 -->
            <div class="order-number">
              <span>订单号：{{ item.orderNumber }}</span>
              <van-icon name="copy" @click="copyOrderNumber(item.orderNumber)" />
            </div>

            <!-- 出发到达信息 -->
            <div class="route-info">
              {{ item.departure }} - {{ item.arrival }}
            </div>

            <!-- 车次和座位信息 -->
            <div class="train-info">
              {{ item.trainNumber }} {{ item.seatInfo }}
            </div>

            <!-- 金额和操作按钮 -->
            <div class="invoice-actions">
              <div class="invoice-amount">
                ￥{{ item.amount.toFixed(2) }}
              </div>
              <div class="action-buttons">
                <!-- 待开票状态显示“开具”按钮 -->
                <van-button
                  v-if="activeTab === 0"
                  style="width: 50px"
                  type="info"
                  size="small"
                  @click="issueInvoice(item)"
                >
                  开具
                </van-button>

                <!-- 已开票状态显示“查看”、“发送邮箱”、“换开发票”按钮 -->
                <template v-if="activeTab === 1">
                  <van-button
                    style="width: 50px"
                    type="info"
                    size="small"
                    @click="viewInvoice(item)"
                  >
                    查看
                  </van-button>
                  <van-button
                    style="width: 80px"
                    type="info"
                    size="small"
                    @click="showEmailDialog(item)"
                  >
                    发送邮箱
                  </van-button>
                  <van-button
                    style="width: 80px"
                    type="info"
                    size="small"
                    @click="reissueInvoice(item)"
                  >
                    换开发票
                  </van-button>
                </template>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </van-pull-refresh>

    <!-- 月份选择器弹窗 -->
    <van-popup v-model="showMonthPicker" position="bottom">
      <van-picker
        :columns="monthColumns"
        @confirm="onMonthConfirm"
        @cancel="showMonthPicker = false"
        show-toolbar
      />
    </van-popup>

    <!-- 邮箱地址确认弹窗 -->
    <van-dialog
      v-model="showEmailConfirmDialog"
      title="邮箱地址确认"
      show-cancel-button
      @confirm="sendEmail"
    >
      <div class="email-dialog-content">
        <p>请核对您的邮箱地址</p>
        <p>- 为确保邮件发送成功，建议您填写国内邮箱地址。</p>
        <p>- 若长时间未收到邮件，请检查您的垃圾邮件。</p>
        <!-- 邮箱输入框 -->
        <van-field
          v-model="invoiceEmail"
          label="邮箱地址"
          placeholder="请输入您的邮箱地址"
          :rules="[{ required: true, message: '请输入邮箱地址' }]"
        />
      </div>
    </van-dialog>


    <verificate
      ref="verificate"
      element=".invoice-list"
      :user-name="username"
      :password="password"
      :sms-check-msg="smsCheckMsg"
      @success="success"
    />

    <face-detection
      ref="face-detection"
      element=".invoice-list"
      :user-name="username"
      :password="password"
      @success="success"
    />


  </div>
</template>

<script>
import {
  NavBar,
  Tab,
  Tabs,
  List,
  Cell,
  Button,
  Icon,
  Toast,
  Popup,
  Picker,
  Dialog,
  Field,
  ImagePreview,
  PullRefresh
} from 'vant';
import {mapGetters} from "vuex";
import {invoiceErrCatch} from 'Utils/tools'
import verificate from '../login/invoice_verificate12306.vue'
import faceDetection from '../login/invoice_face_detection12306.vue'

export default {
  name: 'InvoiceList',
  components: {
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [PullRefresh.name]: PullRefresh,
    verificate,
    faceDetection
  },
  created() {

    if (this.activeTab === 0) {
      this.onloadUnissueInfo()
    }else {
      this.onloadIssueInfo()
    }
  },
  data() {
    // 动态计算过去四个月的日期范围
    const currentDate = new Date();
    const monthColumns = [];
    for (let i = 3; i >= 0; i--) {
      const date = new Date();
      date.setMonth(currentDate.getMonth() - i);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      monthColumns.push({
        text: `${year}年${month}月`,
        value: `${year}-${month}`
      });
    }

    return {
      activeTab: 0, // 当前选中的选项卡（0: 待开票, 1: 已开票）
      selectedMonth: monthColumns[2].value, // 当前选中的月份
      showMonthPicker: false, // 是否显示月份选择器
      showEmailConfirmDialog: false, // 是否显示邮箱地址确认弹窗
      currentEmailItem: null, // 当前操作的发票项
      monthColumns, // 月份选择器的选项
      invoiceList: [
      ],
      invoiceEmail: '',
      smsCheckMsg: '',
      username: '',
      password: '',
      selectedOrderNumber: '',//选择的票号信息
      refreshing: false // 上下拉刷新状态
    };
  },
  computed: {
    // 根据选中的选项卡和月份过滤发票列表
    filteredInvoiceList() {
      const status = this.activeTab === 0 ? 'pending' : 'completed';
      const selectedMonth = this.selectedMonth; // 当前选中的月份
      return this.invoiceList.filter(item => {
        const itemMonth = item.travelDate.slice(0, 7); // 提取年月部分
        return item.status === status && itemMonth === selectedMonth;
      });
    },
    ...mapGetters({
      trainsLoginInfo: 'tr/trSearchInfo'
    }),
  },
  methods: {
    back() {
      this.$router.push({ path: '/userCenter/billInvoice/trainsInvoice' });
    },
    handleTabChange(index) {
      this.activeTab = index;
      if (this.activeTab === 0) {
        this.onloadUnissueInfo()
      }else {
        this.onloadIssueInfo()
      }
    },
    issueInvoice(item) {
      item.isOpen = true
      item.isInvoiceList = true//isInvoiceList 是否为发票列表页面跳转过来
      this.$store.commit('invoice/invoiceDetail', item); //跳转到详情面还会在存储下，防止信息不刷新
      // 这里可以添加开具发票的逻辑
      this.$router.push({
        path: '/userCenter/billInvoice/trainsInvoice/openInvoiceDetail',
        query: { isOpen: true ,invoiceDetail:item}, //isOpen 为true为开发票，否为换开,invoiceDetail当前开具发票的详情信息
      });
    },
    reissueInvoice(item) {
      // 这里可以添加换开发票的逻辑
      item.isOpen = false
      item.isInvoiceList = true//isInvoiceList 是否为发票列表页面跳转过来
      this.$store.commit('invoice/invoiceDetail', item); //跳转到详情面还会在存储下，防止信息不刷新
      this.$router.push({
        path: '/userCenter/billInvoice/trainsInvoice/openInvoiceDetail',
        query: { isOpen: true ,invoiceDetail:item}, // isOpen 为true为开发票，否为换开,invoiceDetail当前开具发票的详情信息
      });
    },
    async viewInvoice(item) {

      var dates = this.selectedMonth.split('-');

      if (dates.length > 1) {
        var year = dates[0]
        var month = dates[1]

        this.loginInfo = this.trainsLoginInfo['12306Info']

        var params = {
          username:this.loginInfo.trainAccount,
          password:this.loginInfo.password,
          ticketNumber:item.orderNumber,
          year: year,
          month: month
        }

        await this.$api['trQuery/invoicePreview'](params).then(res => {
          if(res.errCode == '1') {
            console.log("invoicePreview res{}",res)
            item.imageBase64 = "data:image/png;base64,"+res.data
          } else if(res.errCode == '101' || res.errCode == '100') {
            console.log("登录授权失败"+res.tips)
          } else {
            this.$dialog({
              message: res.errMsg
            })
          }
        }).catch(err => {
          console.log("unissuedInvoicesList error{}",err);
          this.errorCatch(err)
        })

        console.log("加载完后展示发票详情图片信息")
        ImagePreview({
          images: [item.imageBase64],
          closeable: true
        });
      }

    },
    showEmailDialog(item) {
      this.currentEmailItem = item;
      this.showEmailConfirmDialog = true;

      const invoiceEmail = this.$store.getters['invoice/invoiceEmail'];
      if (invoiceEmail) {
        this.invoiceEmail = invoiceEmail;
      }
      this.selectedOrderNumber = item.orderNumber
      console.log("invoiceEmail vuex:{}", invoiceEmail);
    },
    sendEmail() {
      var dates = this.selectedMonth.split('-');

      if (dates.length < 1) {
        Toast('日期选择有问题');
        return;
      }
      var year = dates[0]
      var month = dates[1]

      if (!this.invoiceEmail) {
        Toast('请输入邮箱地址');
        return;
      }
      this.loginInfo = this.trainsLoginInfo['12306Info']

      var params = {
        username:this.loginInfo.trainAccount,
        password:this.loginInfo.password,
        email:this.invoiceEmail,
      }

      this.$api['trQuery/operateEmail'](params).then(res => {
        //设置邮箱成功之后在发送
        if(res.errCode == '1') {
          console.log("operateEmail res{}",res)
          params.year = year;
          params.month = month;
          params.ticketNumber = this.selectedOrderNumber;
          this.sendEmailRequest(params)
        } else if(res.errCode == '101' || res.errCode == '100') {
          console.log("登录授权失败"+res.tips)
        } else {
          this.$dialog({
            message: res.errMsg
          })
          console.log("invoicePreview $dialog{}",err);
        }
      }).catch(err => {
        console.log("unissuedInvoicesList error{}",err);
        this.errorCatch(err)
      })

      // 这里可以添加发送邮箱的逻辑
      //临时保存发送邮箱的数据
      this.$store.commit('invoice/invoiceEmail', this.invoiceEmail);
    },
    sendEmailRequest(params){
      console.log("sendEmailRequest request{}",params)
      this.$api['trQuery/invoiceSendEmail'](params).then(res => {
        //设置邮箱成功之后在发送
        if(res.errCode == '1') {
          Toast(`已发送`);
        } else if(res.errCode == '101' || res.errCode == '100') {
          console.log("登录授权失败"+res.tips)
        } else {
          this.$dialog({
            message: res.errMsg
          })
          console.log("invoicePreview $dialog{}",err);
        }
      }).catch(err => {
        console.log("unissuedInvoicesList error{}",err);
        this.errorCatch(err)
      })

    },
    copyOrderNumber(orderNumber) {
      console.log(orderNumber);
      Toast('订单号已复制');
    },
    onMonthConfirm(value) {
      this.selectedMonth = value.value; // 更新选中的月份
      this.showMonthPicker = false;
      if (this.activeTab === 0) {
        this.onloadUnissueInfo()
      }else {
        this.onloadIssueInfo()
      }
    },
    formatDate(date) {
      // 格式化日期为 MM.DD
      const [year, month, day] = date.split('-');
      return `${month}.${day}`;
    },
    //加载未开票数据
    onloadUnissueInfo() {
      var dates = this.selectedMonth.split('-');

      if (dates.length > 1) {
        var year = dates[0]
        var month = dates[1]
        this.loginInfo = this.trainsLoginInfo['12306Info']
        var params = {
          username:this.loginInfo.trainAccount,
          password:this.loginInfo.password,
          year:year,
          month:month,
        }
        this.$api['trQuery/unissuedInvoicesList'](params).then(res => {
          if(res.errCode == '1') {
            var originalData =  res.data.result;
            // 使用 map 方法进行转换
            var unisseInvoices = originalData.map(item => ({
              travelDate: item.gmtDeparture,
              orderNumber: item.ticketNumber,
              departure: item.departureStation+"("+item.depTime+")",
              arrival: item.arrivalStation+"("+item.arrTime+")",
              trainNumber: item.trainCode,
              seatInfo: item.passengerInfo.seatClassName+" "+item.passengerInfo.coachNo+" "+item.passengerInfo.seatNo,
              amount: item.invoicePriceInfo.price, //可开的发票价格
              status: 'pending', // 待开票
              ticketPrice: item.ticketPrice, // 票价
              name: item.passengerInfo.name, // 姓名
              invoiceDetail: item, // 详情
              year: year, // 年
              month: month, // 月
            }));
            console.log("unisseInvoicesunisseInvoices{}",unisseInvoices)
            this.invoiceList=unisseInvoices
            this.refreshing = false;
            Toast('刷新成功');

          } else if(res.errCode == '101' || res.errCode == '100') {
            console.log("登录授权失败"+res.tips)
          } else {
            this.$dialog({
              message: res.errMsg
            })
            console.log("unissuedInvoicesList $dialog{}",err);
          }
        }).catch(err => {
          console.log("unissuedInvoicesList error{}",err);
          this.errorCatch(err)
        }).finally(() => {
          this.refreshing = false;
        })

      }
    },
    //加载已经开票数据
    onloadIssueInfo() {
      var dates = this.selectedMonth.split('-');

      if (dates.length > 1) {
        var year = dates[0]
        var month = dates[1]
        this.loginInfo = this.trainsLoginInfo['12306Info']
        var params = {
          username:this.loginInfo.trainAccount,
          password:this.loginInfo.password,
          year:year,
          month:month,
        }
        this.$api['trQuery/invoiceHistoryList'](params).then(res => {
          if(res.errCode == '1') {
            var originalData =  res.data.result;
            // 使用 map 方法进行转换
            var issuedInvoices = originalData.map(item => ({
              travelDate: item.gmtDeparture,
              orderNumber: item.ticketNumber,
              departure: item.departureStation+"("+item.depTime+")",
              arrival: item.arrivalStation+"("+item.arrTime+")",
              trainNumber: item.trainCode,
              seatInfo: item.passengerInfo.seatClassName+" "+item.passengerInfo.coachNo+" "+item.passengerInfo.seatNo,
              amount: item.invoicePriceInfo.price,
              status: 'completed', // 已开票
              ticketPrice: item.ticketPrice, // 票价
              name: item.passengerInfo.name, // 姓名
              invoiceDetail: item, // 详情
              year: year, // 年
              month: month, // 月
            }));
            this.invoiceList=issuedInvoices
            this.refreshing = false;
            Toast('刷新成功');

          } else if(res.errCode == '101' || res.errCode == '100') {
            console.log("登录授权失败"+res.tips)
          } else {
            this.$dialog({
              message: res.errMsg
            })
          }
        }).catch(err => {
          this.errorCatch(err)
        }).finally(() => {
          this.refreshing = false;
        })


      }
    },
    onRefresh() {
      if (this.activeTab === 0) {
        this.onloadUnissueInfo()
      }else {
        this.onloadIssueInfo()
      }
    },
    errorCatch(err){
      this.loginInfo = this.trainsLoginInfo['12306Info']
      if(err.errCode == '239001' || err.errCode == '239003') {
        this.$toast.clear()
        this.smsCheckMsg = err.tips
        this.$dialog.alert({
          title: '温馨提示',
          message: '根据铁路局规定，你的账号需要先完成短信核验。',
          confirmButtonText: '去核验',
        }).then(async () => {
          this.$refs['verificate'].toggle()
        })
      } else if(err.errCode == '239002') {
        this.$toast.clear()
        this.$refs['face-detection'].toggle()
        console.log("需要人脸核验")
      }else if(err.errCode == '231100' || err.errCode == '231100') {
        console.log("需登录12306账号 err catch"+err.tips)
        //则将当前12306登录状态修改为false
        this.$store.commit('tr/update12306Info', {
          trainAccount: this.loginInfo.trainAccount,
          password: this.loginInfo.password,
          isLoginSucccess: false,
        });


        Dialog.confirm({
          title: '12306授权',
          message: '需要12306重新授权操作',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonColor: '#07c160',
          cancelButtonColor: '#ee0a24',
        })
          .then(() => {
            this.$router.push('/userCenter/billInvoice/login/theLogin12306');
          })
          .catch(() => {
            // 用户点击取消按钮
            Toast.fail("取消授权！");
            // 在这里执行取消后的操作
          });


      }else if(err.errCode == '101' || err.errCode == '100') {
        console.log("登录授权失败 err catch"+err.tips)
      }else {
        console.log("获取发票抬头列表失败")
      }
    },
    success(){
      Toast('核验成功');
      if (this.activeTab === 0) {
        this.onloadUnissueInfo()
      }else {
        this.onloadIssueInfo()
      }
    }
  },
  mounted() {
    this.username = this.trainsLoginInfo['12306Info'].trainAccount
    this.password = this.trainsLoginInfo['12306Info'].password

  }
};
</script>

<style scoped>
.invoice-list {
  background-color: #f7f8fa;
  min-height: 100vh;
}

/* 月份选择器样式 */
.month-picker {
  padding: 8px 12px;
  font-size: 14px;
  background-color: #fff;
  border-bottom: 1px solid #ebedf0;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: fit-content; /* 宽度根据内容自适应 */
}

.month-picker .van-icon {
  margin-right: 8px;
  color: #1989fa;
}

/* 发票列表容器 */
.invoice-container {
  padding: 8px 16px;
}

/* 订单号单独一行 */
.order-number {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.order-number .van-icon {
  color: #1989fa;
  cursor: pointer;
}

/* 乘车日期 */
.travel-date {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 出发到达信息 */
.route-info {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
}

/* 车次和座位信息 */
.train-info {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

/* 金额和操作按钮 */
.invoice-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.invoice-amount {
  font-size: 14px;
  color: #ee0a24;
}

.action-buttons {
  display: flex;
  gap: 8px; /* 按钮之间的间距 */
}

.action-buttons .van-button {
  flex-shrink: 0; /* 防止按钮被压缩 */
}

/* 邮箱确认弹窗内容 */
.email-dialog-content {
  padding: 16px;
  font-size: 14px;
  color: #333;
}
</style>
